import { render } from "./schoolCard.vue?vue&type=template&id=31f599dc"
import script from "./schoolCard.vue?vue&type=script&lang=js"
export * from "./schoolCard.vue?vue&type=script&lang=js"

import "./schoolCard.vue?vue&type=style&index=0&id=31f599dc&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__